import React from 'react';

import { Pills } from 'components/common/pills/pills';

import classes from 'components/widgets/DistributionGraph/components/QSRAParameters/QSRAParameters.module.scss';

export const QSRAParameters = ({ numOfIterations, taskVersionLabel }) => {
    return (
        <div className={classes.QSRAParameters}>
            <Pills>
                Target Activity: <span className={classes.value}>{taskVersionLabel}</span>
            </Pills>
            <Pills>
                Number of iterations: <span className={classes.value}>{numOfIterations}</span>
            </Pills>
        </div>
    );
};
